import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { useLocale } from '../i18n/LocaleContext';
import { useRef } from 'react';

export default function SessionWarning({
  open,
  remaining,
  onContinue,
}: {
  open: boolean;
  remaining: number;
  onContinue: () => void;
}) {
  const { t } = useLocale();
  const continueButton = useRef<HTMLButtonElement>(null);
  return (
    <Dialog
      open={open}
      aria-labelledby="session-warning-title"
      aria-describedby="session-warning-description"
      TransitionProps={{ onEntered: () => continueButton.current?.focus() }}
    >
      <DialogTitle id="session-warning-title">{t('auth.inactivityWarning')}</DialogTitle>
      <DialogContent>
        <DialogContentText id="session-warning-description">
          {t('auth.inactivityCountdown', { seconds: String(remaining) })}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button ref={continueButton} onClick={onContinue}>
          {t('auth.keepSession')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
